export const skillsData = [
    'HTML',
    'CSS',
    'Bootstrap',
    'MaterialUI',
    'Javascript',
    'React',
    'Node JS',
    'MongoDB',
    'MySQL',
    'Git',
    'AWS'
]